var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shicigame-layout" }, [
    _c("div", { staticClass: "layout-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("div", { staticClass: "header-left" }, [
          _c("h1", { staticClass: "site-title" }, [_vm._v("诗词游戏")]),
          _vm._v(" "),
          _c(
            "nav",
            { staticClass: "nav-menu" },
            [
              _c(
                "router-link",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.$route.path === "/shicigame" },
                  attrs: { to: "/shicigame" },
                },
                [_vm._v("\n            游戏\n          ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.$route.path === "/shicibackup" },
                  attrs: { to: "/shicibackup" },
                },
                [_vm._v("\n            背书\n          ")]
              ),
              _vm._v(" "),
              _vm.isAdmin
                ? _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.$route.path === "/shicifetch" },
                      attrs: { to: "/shicifetch" },
                    },
                    [_vm._v("\n            诗词抓取\n          ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isAdmin
                ? _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      class: {
                        active: _vm.$route.path.indexOf("/manager") === 0,
                      },
                      attrs: { to: "/manager/users" },
                    },
                    [_vm._v("\n            后台管理\n          ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _vm.username
              ? _c(
                  "div",
                  { staticClass: "user-info" },
                  [
                    _c("span", { staticClass: "username" }, [
                      _vm._v(_vm._s(_vm.username)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "logout-btn",
                        attrs: { type: "danger", size: "small" },
                        on: { click: _vm.handleLogout },
                      },
                      [_vm._v("退出")]
                    ),
                  ],
                  1
                )
              : _c(
                  "router-link",
                  { staticClass: "login-link", attrs: { to: "/shicilogin" } },
                  [_vm._v("登录")]
                ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout-content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }